import {
    DriversEtaAttributes,
    FleetsConfigAttributes,
    PriceMatrixAttributes,
    QuoteDenyingConfigAttributes,
    SmartFleetChoiceAttributes,
} from '../../../../server/src/models';
import { ClientCredentials } from '../../types/Client';
import {
    APIForwarder,
    AutoStacking,
    ClientFeatureConfig,
    FullEta,
    JSONTransform,
    PreparationTime,
    Webhook,
    ClosingTool,
    E2EFlow,
} from '../../types/Feature';
import { FORM_MODE } from '../../types/Form';

export interface FormConfigInterface {
    formMode: string;
    isAddMode: boolean;
    isEditMode: boolean;
    isDetailMode: boolean;
    setupModes: {
        [key: string]: {
            title: string;
            submitButtonTitle: string;
        };
    };
}

export const initClientFormConfig = (mode: string): FormConfigInterface => ({
    formMode: mode,
    isAddMode: mode === FORM_MODE.ADD,
    isEditMode: mode === FORM_MODE.EDIT,
    isDetailMode: mode === FORM_MODE.DETAIL,
    setupModes: {
        [FORM_MODE.ADD]: {
            title: 'Add client',
            submitButtonTitle: 'Add',
        },
        [FORM_MODE.EDIT]: {
            title: 'Edit client',
            submitButtonTitle: 'Save',
        },
        [FORM_MODE.DETAIL]: {
            title: 'Client details',
            submitButtonTitle: 'Edit',
        },
    },
});

export interface FeaturesFormData {
    fleets?: ClientFeatureConfig<FleetsConfigAttributes> | undefined;
    autostacking?: ClientFeatureConfig<AutoStacking> | undefined;
    webhook?: ClientFeatureConfig<Webhook> | undefined;
    apiForwarder?: ClientFeatureConfig<APIForwarder> | undefined;
    jsonTransform?: Array<ClientFeatureConfig<JSONTransform>> | undefined;
    clientCredentials?: ClientCredentials | undefined;
    priceMatrix?: ClientFeatureConfig<PriceMatrixAttributes> | undefined;
    driversEta?: ClientFeatureConfig<DriversEtaAttributes>;
    smartFleetChoice?: ClientFeatureConfig<SmartFleetChoiceAttributes>;
    quoteDenying?: ClientFeatureConfig<QuoteDenyingConfigAttributes>;
    fullEta?: ClientFeatureConfig<FullEta>;
    preparationTime?: ClientFeatureConfig<PreparationTime>;
    closingTool?: ClientFeatureConfig<ClosingTool>;

    e2eFlow?: ClientFeatureConfig<E2EFlow>;
}

export const DEFAULT_FEATURE_FORM_DATA: FeaturesFormData = {
    fleets: undefined,
    autostacking: undefined,
    webhook: undefined,
    apiForwarder: undefined,
    jsonTransform: undefined,
    priceMatrix: undefined,
    driversEta: undefined,
    smartFleetChoice: undefined,
    quoteDenying: undefined,
};
